module.exports = __webpack_public_path__ + "img/icon_map_37_on_011.a4786fb1.png";